<template>
  <div>
    <div
      v-if="loading"
      class="text-center p-5"
    >
      Loading form...
    </div>
    <div
      v-else-if="loadError"
      class="text-center p-5 text-danger"
    >
      {{ loadError }}
    </div>
    <template v-else>
      <div>
        <div class="formWrapper niche-wr filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          REV: 5
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>Sales order - little buddha 佛像供奉权认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="payment-plan-section">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle">
                    <p>I hereby agree to purchase the licence for a Buddha Worshipping specified hereunder at the purchase price specified herein upon the terms and subject to the conditions stated overleaf.</p>
                    <h4>本人同意购买下列供养佛像位之功奉权，售价注明如下，并遵守背页所附的条件。</h4>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of purchaser 购买者资料</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Full Name as in NRIC / Passport <br>身份证 / 护照上的全名
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerName || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      NRIC/ Passport No <br>身份证/ 护照号码
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerNric || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Nationality <br>国籍
                    </div>
                    <div class="ssfp-text-field-input-2">
                      {{ formData.customerNationality || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Birth Date <br>出生日期
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerDob || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Sex <br>性別
                    </div>
                    <div class="ssfp-text-field-input-3">
                      <div
                        class="ssfp-check-box"
                        :class="{ active: formData.customerSex === 'Male' }"
                      >
                        Male 男
                      </div>
                      <div
                        class="ssfp-check-box"
                        :class="{ active: formData.customerSex === 'Female' }"
                      >
                        Female 女
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Permanent Address <br>永久地址
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.permanentAddress }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Correspondence Address <br>通讯地址
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.correspondenceAddress }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      E-mail Address <br>电邮
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerEmail || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Contact No. <br>联络号码
                    </div>
                    <div class="ssfp-text-field-input-2">
                      {{ formData.customerContact || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>end user 供奉人</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="">
                <b-col cols="12">
                  <div class="endUserTable">
                    <table>
                      <tr
                        v-for="(pair, rowIndex) in userPairs"
                        :key="'row-' + rowIndex"
                      >
                        <td>{{ pair[0] ? pair[0].name : '-' }}</td>
                        <td>{{ pair[1] ? pair[1].name : '-' }}</td>
                      </tr>
                    </table>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of buddha worshipping location to which this licence relates  供养佛像位置相关资料</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="ssfp-pl-block floatCss">
                    <h3>Location: {{ formData.nicheNo }}</h3>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-pl-single-row">
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div class="ssfp-pl-block floatCss">
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Buddha Worshipping 供养佛像
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        $ {{ numberFormat(formData.productPrice) }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        GST 消费税 {{ formData.gstPercentage || 9 }}%
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        $ {{ numberFormat(formData.gstAmount || 0) }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        <strong>Total 总额</strong>
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        <strong>$ {{ numberFormat(formData.totalAmount || 0) }}</strong>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div class="ssfp-pl-block-right nsf-right floatCss">
                    <h3>Period</h3>
                    <p>{{ dateFormat(formData.worshipPeriodStart) }} - {{ dateFormat(formData.worshipPeriodEnd) }}</p>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="pp-paragraph">
                    <p>I have read, consent and agree to the collection, use and disclosure of my personal data for the purposes listed and in accordance with the terms as set out in the attached Customer Privacy Policy Statement and Customer Personal Data Confirmation.</p>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of Sales and Service Agent  销售代理及服务代理资料</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-pl-single-row">
                <b-col
                  cols="8"
                  md="8"
                  lg="8"
                >
                  <div class="ssfp-pl-block floatCss">
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Agency 区代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.salesAgentAgency }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Sales Agent 销售代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.salesAgentName }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Agency 区代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.serviceAgentAgency }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Service Agent 服务代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.serviceAgentName }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div class="page-break-after"></div>
        <div class="formWrapper filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          REV: 5
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>Sales order - little buddha 佛像供奉权认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>Personal Data Consent 个人资料使用同意书</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-ssfp-check-info active floatCss">
                    I further declare that the Company has made available to me, the Company’s Customer Privacy Policy Statement (“Statement”) as required under the Personal Data Protection Act (Act 26 of 2012), and having read and inspected the same, hereby agree that I consent to the Company processing my personal data, and confirm that I have authority to provide the personal data of any third parties for processing by the Company in accordance with the Notice.
                  </div>
                </b-col>
              </b-row>
              <template v-if="formData.isAgentPurchase">
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle2">
                      <h2>agent self purchase DECLARATION 代理人自购声明</h2>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div class="nsf-custom-tittle1 floatCss">
                      <h4>Cooling-Off Period</h4>
                      <p>Where the Service Advisor is a purchaser of any product, the "Cooling-Off" period shall be sixty (60) days.</p>
                      <h4>Refund During Cooling-Off Period</h4>
                      <ol>
                        <li>
                          Refund request must be submitted within the "Cooling-Off" period by completing the relevant Form(s) as follow:
                          <ol>
                            <li>
                              <h5>For cancellation and refund</h5>
                              <p>Complete Form II and submit the signed Form II together with customer copy of Sales Order and all temporary receipt/official receipt.</p>
                            </li>
                            <li>
                              <h5>For cancellation and transfer payment to other file(s) under same purchaser</h5>
                              <p>Complete Form I and submit the signed Form I together with customer copy of Sales Order and all temporary receipt/official receipt.</p>
                            </li>
                          </ol>
                        </li>
                        <li>The refund shall be subject to such deduction (i.e. processing fee, terminal charges and etc) as may be appropriate.</li>
                        <li>Refund will be made to Purchaser within 30 days upon receipt of signed form with complete submission of all required documents.</li>
                      </ol>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div class="pp-ssfp-check-info nsf-cm-1 active floatCss">
                      I acknowledge this is an agent purchase and the terms of the cooling-off period that applies to agent purchases.
                    </div>
                  </b-col>
                </b-row>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>marketing consent 声明</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle3 floatCss">
                    <p>From time to time, the Group may use personal data disclosed by you in this Form to send you advertising and promotional material. If you do not wish to receive such material, kindly check the box below.</p>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div
                    class="pp-ssfp-check-info floatCss"
                    :class="{ 'active': formData.marketingDataConsent == 'true' }"
                  >
                    No, I would not like to receive advertising and promotional material from the Group.
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row
            class="ssfp-signature"
          >
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <p>Purchaser 购买者签名</p>
              </div>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="formData.signOne"
                    class="pp-signature-block floatCss"
                  >
                    <img
                      :src="formData.signOne"
                      alt="signature"
                    >
                  </div>
                  <div
                    v-else
                    id="signOne"
                    class="pp-signature-block signature-block-yellow floatCss"
                  >
                    <span>Sign here</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <h4>Name 姓名: {{ formData.customerName }}</h4>
                <h4>Date 日期: {{ (formData.signOneDate ? dateFormatWithTime(formData.signOneDate) : '') }}</h4>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div
          class="page-break-after"
        ></div>
        <div
          class="formWrapper filled"
        >
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          REV: 5
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>Sales order - little buddha 佛像供奉权认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pp-paragraph">
                <p>All purchaser should ensure that the terms and conditions mentioned in the agreement are clearly understood before signing to confirm the purchase.<br>购买者在签署此购买同意书前,务必详读及了解同意书内的一切条规。</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="pp-section-tittle2">
                <h2>TERMS & CONDITIONS</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="tc-single-wrapper floatCss">
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    1
                  </div>
                  <div class="tc-info-rt">
                    <p>Payment must be made payable to "MOUNT PRAJNA LTD." Confirmation of Purchase is subject to cheque clearance.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    2
                  </div>
                  <div class="tc-info-rt">
                    <p>Only the Confirmation of Purchase duly accepted by MOUNT PRAJNA LTD. is valid and binding on MOUNT PRAJNA LTD. There shall be no refund for whatsoever reason after Confirmation of Purchase.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    3
                  </div>
                  <div class="tc-info-rt">
                    <p>The nominee's name plate for the Buddha Worshipping will be installed within thirty (30) days from the date of the full payment of the purchase price.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    4
                  </div>
                  <div class="tc-info-rt">
                    <p>Any transfer or change of the nominee's name is strictly not allowed in whatsover manner after installation.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    5
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>The Company reserves the right to amend any of the above mentioned terms and conditions as it deems fit and necessary without prior notice.</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    6
                  </div>
                  <div class="tc-info-rt">
                    <p>The English version shall prevail in the event of dispute in the interpretation of the terms and conditions hereof</p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="pp-section-tittle2">
                <h2>购买条规</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="tc-single-wrapper tc-chns-list floatCss">
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    1
                  </div>
                  <div class="tc-info-rt">
                    <p>付款请以支票注明给“MOUNT PRAJNA LTD.”此认购书于支票过账后方为有效。</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    2
                  </div>
                  <div class="tc-info-rt">
                    <p>只有经过富贵山庄有限公司盖章核收的认购书方为有效。确认书生效后,不得以任何理由退款。</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    3
                  </div>
                  <div class="tc-info-rt">
                    <p>供奉者姓名将在购买者付清全部款项后的30日内按上。</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    4
                  </div>
                  <div class="tc-info-rt">
                    <p>任何佛尊像的供奉者姓名按上后,将不得转让或更改。</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    5
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>公司保留权利在未先通知下,更改以上任何的条规与条件。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    6
                  </div>
                  <div class="tc-info-rt">
                    <p>如对上述条规的中文译本,有任何诠释上的争议,将以英文译本为诠释的唯一标准。</p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-signature">
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <p>Purchaser 购买者签名</p>
              </div>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="formData.signTwo"
                    class="pp-signature-block floatCss"
                  >
                    <img
                      :src="formData.signTwo"
                      alt="signature"
                    >
                  </div>
                  <div
                    v-else
                    id="signTwo"
                    class="pp-signature-block signature-block-yellow floatCss"
                  >
                    <span>Sign here</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <h4>Name 姓名: {{ formData.customerName }}</h4>
                <h4>Date 日期: {{ (formData.signTwoDate ? dateFormatWithTime(formData.signTwoDate) : '') }}</h4>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: {},
      loading: true,
      loadError: null,
    }
  },
  computed: {
    userPairs() {
      const pairs = []
      // "end user 供奉人" section (who the worship is actually for) - endUsers, not
      // intendedUsers (a different concept, the submission's own nominees).
      const users = this.formData.endUsers || []
      for (let i = 0; i < users.length; i += 2) {
        pairs.push([users[i], users[i + 1] || null])
      }
      return pairs
    },
  },

  created() {
    this.loadFormData()
  },

  methods: {
    // App opens this page in a webview with the saved form's id (route param) - fetches the
    // data the app earlier saved via POST /sales/form/little-buddha/data instead of reading injected
    // localStorage, which is what the Puppeteer-rendered source form still does.
    //
    // This hits the front-end/ router (optionalAuth, no token required - the id itself is the
    // access control), not reservation-app/ - so this.$http is safe to use here: no 401 is
    // possible, meaning its global interceptor's hard-redirect-to-/login (src/libs/axios.js)
    // never triggers.
    loadFormData() {
      const { id } = this.$route.params
      this.$http.get(`front-end/sales/form/little-buddha/data/${id}`)
        .then(response => {
          this.formData = response.data.data
          this.loading = false
        })
        .catch(error => {
          this.loadError = (error.response && error.response.data && error.response.data.message) || 'Unable to load form data.'
          this.loading = false
        })
    },
    formatDate(date) {
      if (!date) return '-'
      const timezone = process.env.VUE_APP_TIME_ZONE
      return moment(date).utcOffset(timezone).format('DD/MM/YYYY')
    },
  },
}
</script>

<style>
@media print {
  .page-break-after {
    display: block;
    /* ensure block context */
    page-break-before: always;
    /* legacy */
    break-before: page;
  }

  .formWrapper,
  .niche-wr,
  .ssfp-form-wrapper,
  .ssfp-signature {
    page-break-inside: avoid;
    /* legacy */
    break-inside: avoid;
    /* modern */
  }
}
</style>
